import registerAlias from '../../../common/alias/index';
import component from './Alias';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';

export default () =>
    registerAlias({
        containerComponent: component,
        presentationalComponent: component,
        showTool: false,
        tools: {
            selected: [
                TOOLBAR_TOOLS.COLOR,
                TOOLBAR_TOOLS.ICON,
                TOOLBAR_TOOLS.RENAME,
                ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
                ...TOOL_SETS.TRAILING_SELECTED,
            ],
        },
    });
